module.exports = __webpack_public_path__ + "img/Table.e6a37e1d.svg";